import { useEffect, useState } from 'react';
import 'react-calendar-timeline/lib/Timeline.css';
import moment, { Moment } from 'moment';
import styled from 'styled-components';
import { Empty } from 'antd';
import { observer } from 'mobx-react';
import { HSMSContentCard } from '@components/shared';
import { DraggableSlot, getDraggableSlots, TimelineConfigurationProps, TimelineContent } from '@modules/timetable';
import { useMst } from '@models/Root';

const TimelineContentCard = styled(HSMSContentCard)`
  border: 1px solid #d9d9d9;

  .ant-card-body {
    padding: 0;
  }

  background-color: #ffe6c8;
  .rct-hl {
    border-left: none !important;
  }
  .rct-sidebar {
    border-right: 1px solid #f7931c !important;
  }
  .rct-sidebar-row {
    padding-left: 2rem !important;

    &:not(:last-child) {
      border-bottom: 1px solid #f7931c !important;
    }

    &:last-child {
      border-radius: 0 0 0 4px;
    }
  }
  .rct-header-root {
    border-bottom: 1px solid #f7931c !important;
    background-color: #ffe6c8 !important;
    border-radius: 4px 4px 0 0;
  }
  .rct-calendar-header {
    border: none !important;
  }
  .rct-hl {
    background-color: #ffffff !important;
    border-color: #f7931c !important;
    border-bottom: none !important;
    &:first-child {
      border-top: none !important;
    }
    .custom-group {
      padding: 0 1.5rem;
    }
  }
  .title {
    font-size: 12px;
    font-weight: 600;
  }
  .rct-dateHeader {
    border-left: 1px solid #ffb145 !important;
    border-bottom: none !important;
    &:nth-child(odd) {
      background-color: #ffe6c8 !important;
    }
    &:nth-child(even) {
      background-color: #ffe1bc !important;
    }
  }
  .selected-class {
   z-index:1;
  }
`;

export const TimelineConfiguration = observer(({ academicCalendarItems }: TimelineConfigurationProps) => {
  const [draggableSlots, setDraggableSlots] = useState<DraggableSlot[]>([]);
  const { batch, week, timelineGroups } = useMst().timetable;
  const [startTime, setStartTime] = useState<Moment | null>(moment().startOf('isoWeek'));
  const [endTime, setEndTime] = useState<Moment | null>(moment().endOf('isoWeek'));

  useEffect(() => {
    if (week) {
      const newStartTime = moment().year(week.year()).week(week.week()).startOf('isoWeek');
      const newEndTime = moment().year(week.year()).week(week.week()).endOf('isoWeek');

      setStartTime(newStartTime);
      setEndTime(newEndTime);

      // Draggable slots
      const hoursForRange = Math.round(moment.duration(newEndTime.diff(newStartTime)).asHours()) * 2;
      setDraggableSlots(getDraggableSlots(hoursForRange, newStartTime));
    }
  }, [week]);

  if (!week || !batch || !startTime || !endTime || !timelineGroups || timelineGroups.length === 0) {
    return (
      <HSMSContentCard>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Select a week and a batch first" />
      </HSMSContentCard>
    );
  }

  return (
    <TimelineContentCard id="timetable-timeline">
      <TimelineContent
        startTime={startTime}
        endTime={endTime}
        draggableSlots={draggableSlots}
        academicCalendarItems={academicCalendarItems}
      />
    </TimelineContentCard>
  );
});
